exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-thumb[data-v-9ab8f574]{width:32px;height:32px;margin-right:12px;border-radius:50%}.team-role[data-v-9ab8f574]{margin-left:10px}.form-grid[data-v-9ab8f574]{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));column-gap:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ab8f574","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/site-content/AskAnExpert.vue
// module id = 538
// module chunks = 0